import { createSelector } from "reselect";
import { AppState } from "app/shared/store/root.reducer";

const getStore = (state: AppState) => state.transferForeign;
const getDataCreate = (state: AppState) => state.transferForeign.dataCreate;
const getAccountCredit = (state: AppState) => state.transferForeign.accountCredit;
const getResponseMakeFee = (state: AppState) => state.transferForeign.responseMakeFee;
const getResponseCreated = (state: AppState) => state.transferForeign.responseCreate;
const getResponseConfirm = (state: AppState) => state.transferForeign.responseConfirm;
const getResponseAuth = (state: AppState) => state.transferForeign.responseAuth;

export const getTransferForeignStoreSelector = createSelector(getStore, (data) => data);
export const getTransferForeignDataCreateSelector = createSelector(getDataCreate, (data) => data);
export const getTransferForeignAccountCreditSelector = createSelector(getAccountCredit, (account) => account);
export const getTransferForeignMakeFeeSelector = createSelector(getResponseMakeFee, (fee) => fee);

export const getTransferForeignResponseCreatedSelector = createSelector(getResponseCreated, (res) => res);

export const getTransferForeignResponseConfirmSelector = createSelector(getResponseConfirm, (res) => res);

export const getTransferForeignResponseAuthSelector = createSelector(getResponseAuth, (res) => res);
